import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/da29g6dv7gurs51ef9pg";

export default function ContactForm() {
  const [status, setStatus] = useState<{ type: "idle" | "loading" | "success" | "error"; msg: string }>({
    type: "idle",
    msg: "",
  });

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐检测：若被自动填充则假装成功，不发送任何请求
    const honeypot = String(fd.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus({ type: "success", msg: "感谢你的留言，我们会尽快查看。" });
      return;
    }

    setStatus({ type: "loading", msg: "正在提交…" });
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = /spam|form data is spam/i.test(serverMsg);

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus({ type: "success", msg: "提交成功！你的留言已收到，感谢支持。" });
        form.reset();
      } else {
        setStatus({
          type: "error",
          msg: serverMsg && serverMsg !== responseText ? serverMsg : "提交失败，请稍后再试。",
        });
      }
    } catch {
      setStatus({ type: "error", msg: "网络异常，提交失败，请稍后再试。" });
    }
  }

  return (
    <form
      data-readdy-form="da29g6dv7gurs51ef9pg"
      onSubmit={handleSubmit}
      className="space-y-4"
      noValidate
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <label className="block">
          <span className="mb-1.5 block text-sm text-foreground-800">你的昵称</span>
          <input
            name="name"
            type="text"
            required
            maxLength={30}
            placeholder="怎么称呼你"
            className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
          />
        </label>
        <label className="block">
          <span className="mb-1.5 block text-sm text-foreground-800">联系邮箱</span>
          <input
            name="email"
            type="email"
            required
            maxLength={60}
            placeholder="you@example.com"
            className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
          />
        </label>
      </div>
      <label className="block">
        <span className="mb-1.5 block text-sm text-foreground-800">留言内容</span>
        <textarea
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="想对甜心剧情站说什么？剧情建议、纠错、投稿都可以～"
          className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
        />
        <span className="mt-1 block text-xs text-foreground-500">最多 500 字</span>
      </label>

      {/* 蜜罐防垃圾字段 */}
      <div className="contact-honeypot">
        <label>
          网站
          <input
            name="website_alt"
            type="text"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
        </label>
      </div>

      <button
        type="submit"
        disabled={status.type === "loading"}
        className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 disabled:opacity-60"
      >
        {status.type === "loading" ? "正在提交…" : "发送留言"}
        {status.type !== "loading" && <i className="ri-send-plane-line" />}
      </button>

      {status.type === "success" && (
        <p className="flex items-center gap-2 rounded-md bg-secondary-100 px-4 py-3 text-sm text-secondary-900">
          <i className="ri-checkbox-circle-line" />
          {status.msg}
        </p>
      )}
      {status.type === "error" && (
        <p className="flex items-center gap-2 rounded-md bg-accent-100 px-4 py-3 text-sm text-accent-900">
          <i className="ri-error-warning-line" />
          {status.msg}
        </p>
      )}
    </form>
  );
}